module.exports = __webpack_public_path__ + "static/network-mobile-768b4d32a00a601dd2068ee66f55a564.svg";